import { Link } from 'react-router-dom';
import { Button } from '../components/ui/Button';

export function NotFound() {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-3 bg-surface-light text-center dark:bg-surface-dark">
      <p className="text-6xl font-black text-slate-200 dark:text-slate-800">404</p>
      <p className="text-slate-500 dark:text-slate-400">This page doesn&apos;t exist.</p>
      <Link to="/">
        <Button variant="secondary" size="sm">
          Back to dashboard
        </Button>
      </Link>
    </div>
  );
}
